'use strict';

let $observerNavLinks; // this is the collection of nav links that will be updated by the intersectionObserver

/**
 * Builds the markup for the cat-tag component, given the folder and subfolder (aka category and subcategory)
 * @param {string} folders A comma-sparated string of folder,subfolder
 * @param {string} theme The category theme that is used to build the styling class. Eg. 'warm' -> 'cat-tag--warm'
 * @returns {string} An HTML string of the cat-tag markup
 */
const buildCatTag = (folders, theme) => {
    const [folder, subfolder] = folders.split(',');
    return `<div class="cat-tag ${theme ? 'cat-tag--' + theme : ''}">
        <div class="cat-tag__cat">${folder}</div>
        ${subfolder ? `<div class="cat-tag__subcat">${subfolder}</div>` : ''}
    </div>`;
};

/**
 * Click event handler for the Compare button.
 * Fetches the compare content asset and displays it in a drawer,
 * with the cat-tag component as the drawer title.
 */
$('.js-compare-category').on('click', function () {
    const $thisButton = $(this);
    const compareUrl = $thisButton.data('compare-url');
    const catTag = buildCatTag($thisButton.data('folders'), $thisButton.data('cat-theme'));

    $.drawer({
        src: compareUrl, // example: Page-AjaxContent?cids=tech-warm-insulating-compare
        title: catTag,
        placement: 'bottom',
        class: 'drawer--tech-compare'
    });
});

/**
 * Click event for the Learn More button.
 * Fetches one or more content assets and displays them in a drawer.
 */
$('.js-show-tech-details').on('click', function () {
    const detailsUrl = $(this).closest('.card').data('details-url');
    $.drawer({
        src: detailsUrl, // example: Page-AjaxContent?cids=tech-DoubleWall,tech-warm-insulating-compare
        placement: 'bottom',
        class: 'drawer--tech-details'
    });
});

/**
 * Closes the drawer when the user clicks on an in-page anchor. Otherwise, the drawer remains open
 * because the user is not navigating to a new page.
 */
$('body').on('click', '.tech-nav__link', function () {
    $(this).closest('.drawer__content').find('.close').trigger('click');
});

/**
 * Handles the intersection occurance.
 * Makes active the button which corresponds to the section that is intersecting.
 * Also calls slideToItem() on the button's overflowSlider, so if the active button is
 * overflowing the container, it will slide into view.
 * @param {Array} entries an array of elements that may be interseting with the hit area of the intersectionObserver.
 */
const observerCallback = function (entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            // activate the button which corresponds to the section that is interseting with the hit area
            const sectionId = entry.target.getAttribute('id');
            const $activeItem = $observerNavLinks.filter('[aria-controls="#' + sectionId + '"]');
            const $ofs = $observerNavLinks.closest('.overflow-slider');

            $observerNavLinks.removeClass('active');
            $activeItem.addClass('active');
            $ofs[0].ofs.slideToItem($ofs, $activeItem);
        }
    });
};

/**
 * Creates the options object for the instersectionObserver, defining the root (document)
 * and rootMargin such that the hit area is a thin horizontal line just under the top-nav element.
 * When a section intersects with this line, the intersectionObserver will call its callback function.
 * ╔═══════════════════╗
 * ║    [ HEADER  ]    ║
 * ║    [ TOP NAV ]    ║
 * ║---┌───────────┐---║ <-- defines an intersection hit area
 * ║   │           │   ║     of 100% wide, 0px tall, placed
 * ║   │           │   ║     just under the top nav element.
 * ║   └───────────┘   ║
 * ║   ┌───────────┐   ║
 * ╚═══╧═══════════╧═══╝
 * Paste this into the console to see the "hit area":
 *   $('body').prepend(`<div style="position: sticky; z-index: 100000; width: 100%; height: 0; border-bottom: 2px dashed orange; left: 0; top: ${parseFloat($('html').css('scroll-padding-top')) + 8}px;"></div>`);
 * @returns {Object} the options object for an intersectionObserver
 */
const observerOptions = () => {
    let headerHeight = $('header').outerHeight() + $('.tech-hub__top-nav').outerHeight() + 16;
    $('html').css('scroll-padding-top', headerHeight);

    const viewportHeight = $(window).height();
    headerHeight += 8; // 0.5rem more than the scroll offset, to ensure we're into the next section.
    const margin = `-${headerHeight}px 0px ${headerHeight - viewportHeight}px 0px`;

    return {
        root: document,
        rootMargin: margin,
        threshold: 0
    };
};

window.addEventListener('load', () => {
    const intersectionObserver = new IntersectionObserver(observerCallback, observerOptions());
    if ($('.tech-hub__subcat-links').length) {
        // we're on a category page (Warm, Dry, Cool, Protected, or Footwear)
        $observerNavLinks = $('.tech-hub__subcat-link');
        $('.tech-hub-subcategory').each((i, section) => {
            intersectionObserver.observe(section);
        });
    } else {
        // we're on the All Tech page
        $observerNavLinks = $('.tech-hub__cat-btn');
        $('.tech-hub-category').each((i, section) => {
            intersectionObserver.observe(section);
        });
    }

    // if we find a named anchor in the page URL that points to a technology card,
    // for example: /tech-hub.html#warmreflective-omni-heat-reflective
    // scroll to that card and auto-open the details drawer.
    if (window.location.hash) {
        document.querySelector(window.location.hash).scrollIntoView();
        // wait for scroll to finish
        setTimeout(() => {
            const $anchor = $(window.location.hash);
            if ($anchor.hasClass('card')) {
                $anchor.find('.js-show-tech-details').first().trigger('click');
            }
        }, 1000);
    }
});
